export enum HublerUnavailabilityReasonsForOffer {
  BLOCKED_SERVICE = 'BLOCKED_SERVICE',
  JOB_PROFILE_MISMATCH = 'JOB_PROFILE_MISMATCH',
  WRONG_EMPLOYMENT_STATUS = 'WRONG_EMPLOYMENT_STATUS',
  MISSING_REQUIRED_INSTITUTION_FIELDS = 'MISSING_REQUIRED_INSTITUTION_FIELDS',
  HUBLER_IS_UNAVAILABLE = 'HUBLER_IS_UNAVAILABLE',
  MISSING_SHIFT_NETWORK_PROFILE = 'MISSING_SHIFT_NETWORK_PROFILE',
}
